module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAECAYAAACk7+45AAAAFklEQVQImWN8P9/qPwMDAwMTAxRgMgBd2QLPgF67uAAAAABJRU5ErkJggg=="